import { ExportOutlined } from '@ant-design/icons';
import { useCrudRecord } from '../../../containers/crud/recordContext';
import { Button, message, Tooltip } from 'antd/lib';
import { ModalTrigger } from '@arivaa-react/components/modal';
import { url } from '../../../constants/api';
import { secureApi } from '../../../hooks/api';
import Form from '@arivaa-react/components/form';
import { useRef } from 'react';
import { useSpinner } from '../../../hooks/useSpinner';

export const AddWebsiteConfig = () => {
  const { key } = useCrudRecord();
  const formRef = useRef();

  const handleFinish = async (values) => {
    const spinner = useSpinner(formRef.current?.formElement);
    try {
      spinner.start();
      const formData = new FormData();
      const file = values.file;

      const text = await file.text();
      JSON.parse(text); // Attempt to parse JSON to validate
      formData.append('file', file);

      await secureApi(url(`website-configurations/${key}/add-config`), {
        body: formData,
        method: 'POST',
      });
      message.success('Configuration added successfully');
    } catch (error) {
      console.error('Error uploading file:', error);
      message.error('Enable to add configuration');
    } finally {
      spinner.stop();
    }
  };

  return (
    <ModalTrigger
      modalProps={{
        title: 'Add Website Configurations',
        footer: null,
      }}
      content={
        <Form
          ref={formRef}
          elements={[
            {
              type: 'file',
              name: 'file',
              label: 'Website Configurations File',
              required: true,
              inputProps: {
                accept: '.json',
              },
            },
          ]}
          onSubmit={handleFinish}
        ></Form>
      }
    >
      <Tooltip title="Add Website Configurations" placement="bottom">
        <Button className="btn blue-btn-text">
          <ExportOutlined />
        </Button>
      </Tooltip>
    </ModalTrigger>
  );
};
